// extracted by mini-css-extract-plugin
module.exports = {"editor":"DayDurationPicker_editor__2D0Q3","label":"DayDurationPicker_label__2t6q2"};